<div class="modal-container" data-testid="device-edit-modal">
  <div class="modal-header">
    <div>{{ 'modal.edit_device.title' | translate }}</div>
    <div class="modal-header-close-btn icon-close" (click)="abortModal()"></div>
  </div>
  <div class="seperator">
    <hr />
  </div>
  <div class="modal-body">
    <div *ngIf="!errorMessage">
      {{ 'modal.edit_device.instruction' | translate }}
    </div>
    <div class="error-message" *ngIf="errorMessage">
      {{ errorMessage }}
    </div>
    <form
      data-testid="device-edit-form"
      [formGroup]="form"
      (ngSubmit)="editDevice()"
    >
      <mat-form-field appearance="outline">
        <mat-label>{{ 'modal.edit_device.name' | translate }}</mat-label>
        <input
          matInput
          data-testid="device-edit-name"
          [placeholder]="'modal.edit_device.name_placeholder' | translate"
          formControlName="name"
        />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>{{ 'modal.edit_device.description' | translate }}</mat-label>
        <textarea
          matInput
          data-testid="device-edit-description"
          [placeholder]="
            'modal.edit_device.description_placeholder' | translate
          "
          formControlName="description"
        ></textarea>
      </mat-form-field>

      <div class="full-width" *ngIf="canAssignCompany">
        <app-autocomplete
          [data]="companies"
          [label]="'modal.edit_device.company' | translate"
          [preSelectedValue]="companyPreSelectedValue"
          propertyName="name"
          optionValuePropertyName="id"
          [formatterFn]="companyFormatter"
          (valueSelected)="onCompanySelected($event)"
        ></app-autocomplete>
        <span class="helper-text" *ngIf="loadingCompanies">
          {{ 'modal.edit_device.company_loading' | translate }}
        </span>
      </div>

      <app-button
        [tall]="true"
        [title]="'modal.edit_device.submit' | translate"
        [disabled]="form.invalid"
        testId="device-edit-submit"
      >
      </app-button>
    </form>
  </div>
</div>
